// extracted by mini-css-extract-plugin
export default {"container":"ErrorDisplay_container__vUJhS","backLink":"ErrorDisplay_backLink__O2F60"};